module.exports = {"validation":{"required":"此字段为必填项","email":"无效的电子邮箱地址"}}